<template>
  <Row>
    <div class="login-header">
      <img src="@/assets/images/logo.png">
    </div>
    <h2 class="login-title">重置密码</h2>
    <Col span="6" offset="9">
    <Alert type="error" v-if="model.errorStr">{{ model.errorStr }}</Alert>
    <Form ref="form" :model="model" :rules="ruleValidate">
      <Form-item prop="username">
        <Input element-id="username" type="text" v-model="model.username" placeholder="请输入用户名">
        </Input>
      </Form-item>
      <Form-item prop="mobile">
        <Input element-id="mobile" type="text" v-model="model.mobile" placeholder="请输入手机号">
        </Input>
      </Form-item>
      <Form-item prop="code">
        <Input type="text" v-model="model.code" placeholder="请输入验证码">
          <span slot="append" v-if="showSendBtn" icon="ios-send" @click="getCode" class="btn-primary">获取验证码</span>
          <span slot="append" v-if="!showSendBtn" class="btn-gray">重新获取 ( {{ count }} s )</span>
        </Input>
      </Form-item>

      <Form-item prop="password">
        <Input type="password" v-model="model.password" placeholder="请输入密码">
        </Input>
      </Form-item>
      <Form-item prop="confirm_password">
        <Input type="password" v-model="model.confirm_password" placeholder="请确认密码">
        </Input>
      </Form-item>

      <Form-item>
        <Button type="primary" @click="handleSubmit('form')" long>提交</Button>
      </Form-item>
      <div class="prompt-msg">
        重新尝试登录，请
        <router-link to="/">登录</router-link>
      </div>
    </Form>
    </Col>
  </Row>
</template>

<script>
import { RequestCode, ResetPassword } from '@/api/sys.login'

export default {
  name: 'active',
  data: function () {
    const validatePassCheck = (rule, value, callback) => {
      if (value !== this.model.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    return {
      model: {
        username: '',
        password: '',
        confirm_password: '',
        mobile: '',
        code: '',
        errorStr: ''
      },
      showSendBtn: true,
      count: '',
      timer: null,
      ruleValidate: {
        username: [
          { required: true, message: '用户名不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { min: 8, message: '密码长度不得小于8', trigger: 'blur' }
        ],
        confirm_password: [
          { required: true, message: '确认密码不能为空', trigger: 'blur' },
          { min: 8, message: '确认密码长度不得小于8', trigger: 'blur' },
          { validator: validatePassCheck, trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '手机号不能为空', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '验证码不能为空', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.postForm()
        }
      })
    },
    postForm: function () {
      ResetPassword(this.model).then(async res => {
        this.model.errorStr = res.error
        if (res.message) {
          this.$store.commit('refresh')
          this.$Message.success('密码已重置，请使用新密码登录应用')
          this.$router.push('/')
        } else {
          this.$Message.error(res.error)
        }
      })
    },
    sendCode: function () {
      RequestCode(this.model).then(async res => {
        this.$Message.success('验证码发送成功')
      })
    },
    getCode: function () {
      const TIME_COUNT = 60
      if (this.model.mobile) {
        if (!this.timer) {
          this.count = TIME_COUNT
          this.showSendBtn = false
          this.sendCode()
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--
            } else {
              this.showSendBtn = true
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        }
      } else {
        this.model.errorStr = '手机号码不能为空'
      }
    }
  }
}
</script>

<style>
.prompt-msg {
  text-align: center;
}
.login-title {
  text-align: center;
  padding: 1% 0 1%;
}
.login-header {
  text-align: center;
  padding: 3% 0;
}
.btn-primary {
  font-weight: bold;
  color: #066de7;
  cursor: pointer;
  padding: 8px;
}
.btn-gray {
  color: #898b8c;
  cursor: wait;
  padding: 8px;
}
</style>
